var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResellers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#6D7781",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.69,2.26l-.62-.62a2.23,2.23,0,0,0-.92-.31h-4a2.23,2.23,0,0,0-.92.31l-.77.62A1.09,1.09,0,0,0,4,3.18V7.49a2.69,2.69,0,0,0,.31.77l1.39,1.85a1.4,1.4,0,0,0,1.08.46H9.53a1,1,0,0,0,.93-.62l1.38-1.84a1.16,1.16,0,0,0,.31-.77V3.18A1.31,1.31,0,0,0,11.69,2.26ZM10.9,7.63,9.51,9.57H6.71L5.13,7.63V3.06l.7-.7h4.38l.69.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.39,14.58v0l-1.07-1.69a.62.62,0,0,0-.59-.37H2.39a.7.7,0,0,0-.48.19l0,0L.74,14.49l0,.07v0s0,0,0,.05v3.73c0,.19.23.3.65.3s.66-.11.66-.3v-3.5l.78-1.23H13.31l.79,1.23v3.5c0,.19.23.3.65.3s.66-.11.66-.3V14.64S15.39,14.6,15.39,14.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.58,2.26,15,1.64A2.19,2.19,0,0,0,14,1.33H12.7v1h1.4l.7.7V7.63L13.4,9.57h-.7v1h.72a1,1,0,0,0,.93-.62l1.38-1.84A1.16,1.16,0,0,0,16,7.34V3.18A1.31,1.31,0,0,0,15.58,2.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.28,14.58v0l-1.08-1.69a.61.61,0,0,0-.59-.37H15.87v1.16h1.34L18,14.87v3.5c0,.19.23.3.66.3s.65-.11.65-.3V14.64A.14.14,0,0,0,19.28,14.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellers);
export default __webpack_public_path__ + "static/media/resellers.72e06ba0.svg";
export { ForwardRef as ReactComponent };